import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_SchedulerTimingOutputTimingTab = _resolveComponent("SchedulerTimingOutputTimingTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_SchedulerTimingOutputOutputTab = _resolveComponent("SchedulerTimingOutputOutputTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_SchedulerTimingOutputWarningDialog = _resolveComponent("SchedulerTimingOutputWarningDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.schedulerTimingOutputDetailDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.timingAndOutput')), 1)
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            class: "kn-progress-bar",
            mode: "indeterminate"
          }))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: _ctx.saveDisabled,
          onClick: _ctx.saveTrigger
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TabView, { id: "timing-tabs" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.scheduler.timing')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_SchedulerTimingOutputTimingTab, {
                propTrigger: _ctx.trigger,
                datasets: _ctx.datasets,
                onCronValid: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCronValid($event)))
              }, null, 8, ["propTrigger", "datasets"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.output')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_SchedulerTimingOutputOutputTab, {
                propDocuments: _ctx.trigger.documents,
                functionalities: _ctx.functionalities,
                datasets: _ctx.datasets,
                jobInfo: _ctx.jobInfo
              }, null, 8, ["propDocuments", "functionalities", "datasets", "jobInfo"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_SchedulerTimingOutputWarningDialog, {
        visible: _ctx.warningVisible,
        warningTitle: _ctx.warningTitle,
        warningMessage: _ctx.warningMessage,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warningVisible = false))
      }, null, 8, ["visible", "warningTitle", "warningMessage"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}